import {api} from './api';

const header = (token) => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// fetch all events
const fetchEvents = (token) => {
    return api.get('event/events', header(token));
  };
export const EventServices = {
  fetchEvents,
};